module.exports = __webpack_public_path__ + "img/fruit-plums-190x100.08933f65.jpg";